module.exports = __webpack_public_path__ + "static/media/generate-token.d3323ca9.jpg";